<template>
    <div id="aqt_content">
      <div class="content_body">
        <div class="case_all">
          <div class="line line1"></div>
          <p class="case_title">阿启泰项目案例</p>
          <p class="case_brief">阿启泰自成立以来，已服务大量客户，并与多家第三方机构建立了稳定的战略合作关系。</p>
          <img src="../../assets/img/case1.png" class="case_img"/>
        </div>
        <div class="pc_case" style="display: none">
          <div class="pc_case_title case_title">
            <img src="../../assets/img/personal13.png" class="case_title_img1"/>
            <p class="case_title1">PC端项目案例</p>
          </div>
          <ul class="case-items">
            <li class="case_item" v-for="(pc_case,index) in pc_cases" :key="index+1">
              <p class="case_item_content">{{pc_case.title}}</p>
              <p class="case_item_from">{{pc_case.belong}}</p>
            </li>
          </ul>
        </div>
        <div class="move_case" style="display: none">
          <div class="move_case_title case_title">
            <img src="../../assets/img/personal13.png" class="case_title_img1"/>
            <p class="case_title1">移动端项目案例</p>
          </div>
          <ul class="move_items">
            <li class="move_item" v-for="(move_case,index) in move_cases" :key="index+2">
              <p class="case_item_content">{{move_case.title}}</p>
              <p class="case_item_from">{{move_case.belong}}</p>
            </li>

          </ul>
        </div>
      </div>
    </div>

</template>

<script>
  import Vue from 'vue';
  import axios from 'axios'
  Vue.prototype.$http=axios
    export default {
      data(){
        return {
          pc_cases:[],
          move_cases:[],
          case_classify:[]
        }
      },
      methods:{
        getCase(id){
          const that=this;
          let url;
          url="http://admin.aqitai.com/Home/Index/ArticleList?cate_id="+id;
          if(id=="9"){
            axios.get(url).then(data =>{
              that.pc_cases=data.data.data;
            }).catch(error=>{
              alert("当前网络不佳...")
            })
          }else if(id=="12"){
            axios.get(url).then(data =>{
              that.move_cases=data.data.data
            }).catch(error =>{
              alert('当前网络不佳...')
            })
          }
        },
        getClassfy(){
          const that=this;
          var url="http://admin.aqitai.com/Home/Index/CateList?type=2";
          axios.get(url).then(data =>{
            that.case_classify=data.data.data;
          }).catch(error=>{
            alert("当前网络不佳...")
          })

        }
      },
      mounted(){
        const that=this;
        // that.getCase(9);
        // that.getCase(12)
        // that. getClassfy()
      }
    }
</script>

<style  scoped lang="less">
  #aqt_content{
    padding-bottom: 5%;
    padding-top:70px;
    .content_body{
      width:70%;
      height:auto;
      margin:0 auto;

      .line{
        width:10%;
        height:1px ;
      }
      .line1{
        background-color:#F5A623;
        margin:50px auto;
      }
      .case_title{
        text-align:center;
        font-size:18px;
        color:#F4FAFF;
        margin-top:30px;
        margin-bottom:30px;
      }
      .case_brief{
        text-align:center;
        color:#D3DFFF;
        font-size:14px;
      }
      .case_img{
        width: 28%;
        margin-top: 50px;
        margin-left: 36%;
        margin-bottom: 100px;
      }

      .pc_case{
        width:100%;
        height:auto;
        .case_title{
          width:100%;
          height:50px;
          display:flex;
          flex-direction:row;

          .case_title_img1{
            width:20px;
            height:20px;
            margin-left:40%;
          }
          .case_title1{
            font-size:16px;
            color:#F4FAFF;
            margin-left:10px;
          }
        }
        .case-items{
          width:100%;
          height:auto;
          display:flex;
          flex-direction:row;
          flex-wrap: wrap;
          .case_item{
            width:50%;
            height:auto;
            margin-bottom:15px;
            color:#D3DFFF;
            .case_item_content{
              font-size:14px;
              text-indent:20%;
            }
            .case_item_from{
              font-size:8px;
              margin-top:5px;
              text-indent:20%;
            }
          }
        }
      }
      .move_case{
        margin-top:15%;
        .move_case_title{
          display:flex;
          flex-direction:row;
          margin-bottom:5%;
          .case_title_img1{
            width:20px;
            height:20px;
            margin-left:40%;
          }
          .case_title1{
            margin-left:10px
          }
        }
        .move_items{
          width:100%;
          display:flex;
          flex-direction:row;
          flex-wrap:wrap;
          color:#D3DFFF;
          .move_item{
            width:33%;
            height:auto;
            margin-bottom:15px;
            margin-right:2px;
            .case_item_content{
              font-size:14px;
              text-indent:23%;

            }
            .case_item_from{
              font-size:8px;
              margin-top:5px;
              text-indent:23%;
            }
          }
        }
      }
    }

  }

</style>
